import React, {ComponentProps, forwardRef, MutableRefObject} from "react";
import {Billboard, Text} from "@react-three/drei";
import {Group} from "three";

type TextMarkerProps = {
  text: string;
  position: ComponentProps<typeof Billboard>['position'];
  innerTextRef?: MutableRefObject<{ text: string }>;
  fontSize?: number;
};

/**
 * Text label / marker at the given position in the scene which is always rotated to face
 * the camera such that it appears as an "overlay" or HUD on top of the 3D scene.
 * TODO add small line going up from the text to the exact coordinate
 */
export const TextMarker = forwardRef<Group, TextMarkerProps>((
  {
    text,
    position,
    innerTextRef,
    fontSize = .2
  }, ref) => {

  return <group position={position} ref={ref}>
    <Billboard
      follow={true}
      lockX={false}
      lockY={false}
      lockZ={false}
    >
      <Text fontSize={fontSize} ref={innerTextRef}>{text}</Text>
    </Billboard>
  </group>;
});